/**
 * Cleanup Ledger (P1) wire types — see docs/cleanup-ledger-spec.md.
 *
 * A CLAIM LEDGER, not a dispatch workflow: no status/assignment fields.
 * Mirrors the backend's CleanupEventCreateBodySchema/CleanupEventSchema
 * (dregsbane-web-backend/src/lib/schema.ts) — kept local-for-now per the
 * existing @dregsbane/web-types TODO in api.ts rather than a shared
 * package dependency.
 */

export type AmountBucket = 'handful' | 'bag' | 'several_bags' | 'all';

/**
 * UI surfaces always render prose, never raw enum values (AGENTS.md
 * convention — see ContributionsList's OBJECT_LABEL for the pattern
 * this mirrors). Matches the spec's exact wording for the bucket picker.
 */
export const AMOUNT_BUCKET_LABEL: Record<AmountBucket, string> = {
  handful: 'a handful (~10)',
  bag: 'a grocery bag (~50)',
  several_bags: 'several bags',
  all: 'all of it',
};

export const AMOUNT_BUCKETS: readonly AmountBucket[] = [
  'handful',
  'bag',
  'several_bags',
  'all',
];

/** One ledger detail row — a single logged claim against a scene. */
export interface CleanupEvent {
  id: string;
  scene_observation_id: string;
  cleaned_at: string;
  amount_bucket: AmountBucket;
  items_estimate: number;
  /** Opt-in; render "a neighbor" client-side when null (spec). */
  display_name: string | null;
  /** On-behalf-of org name, when the claim was logged for an org. */
  org_name: string | null;
  verified: boolean;
}
